import { Fragment, useRef, useState } from 'react';

import gradeDescriptionShowMoreButtonClick from '@hh.ru/analytics-js-events/build/career_platform/profession/profession_grade_description_show_more_button_click';
import { TranslatedComponent, translation } from '@hh.ru/front-static-app';
import { Text, useCollapsible } from '@hh.ru/magritte-ui';
import { useSelectorNonNullable } from '@hh.ru/redux-create-reducer';

import DottedList from 'src/components/DottedList';

import styles from './styles.less';

const TrlKeys = {
    showMore: 'career-platform.profession.current-grade-description.show-more',
    hideMore: 'career-platform.profession.current-grade-description.hide-more',
};

interface Props {
    initialShowCount: number;
}

const CurrentGradeDescription: TranslatedComponent<Props> = ({ initialShowCount, trls }) => {
    const { currentGrade } = useSelectorNonNullable((state) => state.pageProfession);

    const visibleItems = currentGrade ? currentGrade.tasks.slice(0, initialShowCount) : [];
    const hiddenItems = currentGrade ? currentGrade.tasks.slice(initialShowCount) : [];

    const hiddenRef = useRef<HTMLDivElement | null>(null);
    const [isExpanded, setIsExpanded] = useState(false);
    const { collapsibleClasses } = useCollapsible(hiddenRef, isExpanded);

    const hiddenCurrentMaxHeightStyle = hiddenRef.current?.style.maxHeight;
    const hiddenMaxHeightStyle = hiddenCurrentMaxHeightStyle
        ? { maxHeight: hiddenCurrentMaxHeightStyle }
        : { maxHeight: isExpanded ? 'none' : 0 };

    const handleShowMoreClick = () => {
        if (!isExpanded) {
            gradeDescriptionShowMoreButtonClick();
        }

        setIsExpanded((currentState) => !currentState);
    };

    if (!currentGrade) {
        return null;
    }

    return (
        <div>
            {currentGrade.description && <Text typography="paragraph-2-regular">{currentGrade.description}</Text>}
            <DottedList strings={visibleItems} typography="paragraph-2-regular" />
            {!!hiddenItems.length && (
                <Fragment>
                    <div className={collapsibleClasses} style={hiddenMaxHeightStyle} ref={hiddenRef}>
                        <DottedList strings={hiddenItems} typography="paragraph-2-regular" />
                    </div>
                    <div className={styles.showMoreContainer}>
                        <Text typography="label-2-regular" style="accent" Element="p" onClick={handleShowMoreClick}>
                            {isExpanded ? trls[TrlKeys.hideMore] : trls[TrlKeys.showMore]}
                        </Text>
                    </div>
                </Fragment>
            )}
        </div>
    );
};

export default translation(CurrentGradeDescription);
